import React from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/Sidebar.css'; 
import LogoImagem from '../img/BTV_ExColorida_Horizontal.png';


function Menu() {
  return (
    <div className="sidebar custom-sidebar">
      <div className="sidebar-header">
      <h3>
        <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>
          <img
            src={LogoImagem} 
            alt="bemtevejo Logo"
            style={{
              width: '200px',  // Aumenta o tamanho da largura
              height: 'auto',  // Mantém a proporção da imagem
              margin: '0 auto' // Centraliza horizontalmente
              }}
          />
        </NavLink>
      </h3>
      </div>
      <ul className="sidebar-list">
        <li>
          <NavLink to="/indicadores" className={({ isActive }) => (isActive ? 'active' : '')}>
            Indicadores 
          </NavLink>
        </li>
        <li>
          <NavLink to="/montarconsulta" className={({ isActive }) => (isActive ? 'active' : '')}>
            Montar Consulta
          </NavLink>
        </li>
        <li>
          <NavLink to="/modelopreditor" className={({ isActive }) => (isActive ? 'active' : '')}>
            Classificador de Postagens 
          </NavLink>
        </li>
        <li>
          <NavLink to="/sobre" className={({ isActive }) => (isActive ? 'active' : '')}>
            Sobre
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default Menu;
